import { useEffect } from "react";

export const useUTM = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmCampaign = searchParams.get("utm_campaign");
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmTerm = searchParams.get("utm_term");
      const utmContent = searchParams.get("utm_content");
    const utmMediumVariant = searchParams.get("utm_medium_variant");
    const utmDevice = searchParams.get("utm_device");
    const utmNetwork = searchParams.get("utm_network");
    const utmPlacement = searchParams.get("utm_placement");
    const utmLocPhysical = searchParams.get("utm_loc_physical");
    
    if (
      !utmCampaign 
      && !utmSource 
      && !utmMedium 
      && !utmTerm 
      && !utmContent
      && !utmMediumVariant
      && !utmDevice
      && !utmNetwork
      && !utmPlacement
      && !utmLocPhysical
    ) return;

    localStorage.setItem("utm_campaign", utmCampaign || "");
    localStorage.setItem("utm_source", utmSource || "");
    localStorage.setItem("utm_medium", utmMedium || "");
    localStorage.setItem("utm_term", utmTerm || "");
    localStorage.setItem("utm_content", utmContent || "");
    localStorage.setItem("utm_medium_variant", utmMediumVariant || "");
    localStorage.setItem("utm_device", utmDevice || "");
    localStorage.setItem("utm_network", utmNetwork || "");
    localStorage.setItem("utm_placement", utmPlacement || "");
    localStorage.setItem("utm_loc_physical", utmLocPhysical || "");
  }, []);

  const getUTM = (key: string) => {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return value;
  };

  return {
    campaign: getUTM("utm_campaign"),
    source: getUTM("utm_source"),
    medium: getUTM("utm_medium"),
    term: getUTM("utm_term"),
    content: getUTM("utm_content"),
    medium_variant: getUTM("utm_medium_variant"),
    device: getUTM("utm_device"),
    network: getUTM("utm_network"),
    placement: getUTM("utm_placement"),
    loc_physical: getUTM("utm_loc_physical"),
  };
};
